import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ServicePoTokenAuthService {
  private readonly tokenKey = 'servicePoAccessToken';
  private readonly poIdKey = 'servicePoId';
  private readonly supplierIdKey = 'servicePoSupplierId';
  private readonly companyIdKey = 'servicePoCompanyId';

  set(
    servicePoAccessToken: string,
    servicePoId: string | number,
    supplierId?: string | number | null,
    companyId?: string | number | null,
  ): void {
    if (servicePoAccessToken) sessionStorage.setItem(this.tokenKey, servicePoAccessToken);
    if (servicePoId !== undefined && servicePoId !== null) {
      sessionStorage.setItem(this.poIdKey, String(servicePoId));
    }
    if (supplierId !== undefined && supplierId !== null) {
      sessionStorage.setItem(this.supplierIdKey, String(supplierId));
    }
    if (companyId !== undefined && companyId !== null) {
      sessionStorage.setItem(this.companyIdKey, String(companyId));
    }
  }

  clear(): void {
    sessionStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.poIdKey);
    sessionStorage.removeItem(this.supplierIdKey);
    sessionStorage.removeItem(this.companyIdKey);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.tokenKey);
  }

  getPoId(): string | null {
    return sessionStorage.getItem(this.poIdKey);
  }

  getSupplierId(): string | null {
    return sessionStorage.getItem(this.supplierIdKey);
  }

  getCompanyIdId(): string | null {
    return sessionStorage.getItem(this.companyIdKey);
  }

  buildAuthHeaders(): { headers: HttpHeaders } | {} {
    const token = this.getToken();
    if (!token) return {};
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    return { headers };
  }
}
